import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M2 .25h6c.966 0 1.75.784 1.75 1.75v7A1.75 1.75 0 0 1 8 10.75H2A1.75 1.75 0 0 1 .25 9V2C.25 1.034 1.034.25 2 .25Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M8 .25c.966 0 1.75.784 1.75 1.75v7A1.75 1.75 0 0 1 8 10.75H5.25V.25z"
    }, null, -1)
  ]))]))
}
export default { render: render }